// extracted by mini-css-extract-plugin
module.exports = {"Suffix":"styles_Suffix__Jfd6l"};